import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const Pays = ({
  imgsrc,
  title,
  discription,
  reverse,
  subDetail,
  bg,
  btn,
  href,
  hrefExt,
  btnTitle,
  btnSpacing,
  target,
}) => {
  return (
    <>
      {reverse == true ? (
        bg == 'black' ? (
          <div className="test1 grid md:grid-cols-2 mb-12  md:gap-x-12 md:gap-y-14">
            <div className="md:order-2 order-1 ">
              <img loading="lazy" className="img img-fluid w-full" src={imgsrc} alt="" />
            </div>

            <div
              className=" md:order-1 order-2 text-center 
            flex flex-col justify-center items-center">
              <h1
                className="fs-24-30 font-semibold mt-4 md:mt-0 lg:mb-1"
                style={{ fontFamily: 'Josefin Sans', color: '#ffffff' }}>
                {title}
              </h1>
              {discription}

              {btn == false || btn == undefined ? null : href ? (
                <a href={href} target={target && target}>
                  <button
                    type="button"
                    className="btn rounded-0 lg:mt-4 mt-3 mb-4 md:mb-0"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      fontSize: '18px',
                      padding: '13px 30px',
                    }}>
                    {btnTitle ? btnTitle : 'Know more'}
                  </button>
                </a>
              ) : (
                <a href={hrefExt} target="_blank" rel="noreferrer">
                  <button
                    type="button"
                    className="btn rounded-0 lg:mt-4 mt-3 mb-4 md:mb-0"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      fontSize: '18px',
                      padding: '13px 30px',
                    }}>
                    {btnTitle ? btnTitle : 'Know more'}
                  </button>
                </a>
              )}
            </div>
          </div>
        ) : (
          <div className="test2 grid md:grid-cols-2 mb-12  md:gap-x-12  md:gap-y-14">
            <div className=" md:order-2 order-1 ">
              <img loading="lazy" className="img img-fluid w-full" src={imgsrc} alt="" />
            </div>
            <div
              className=" md:order-1 order-2 text-center
            flex flex-col justify-center items-center">
              <h1
                className="fs-24-30 font-semibold mt-4 md:mt-0 lg:mb-1"
                style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                {title}
              </h1>
              <p
                className=" lg:mt-2 "
                style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px', fontSize: '18px' }}>
                {discription}
              </p>
              {btn == false || btn == undefined ? null : href ? (
                <a href={href} target={target && target}>
                  <button
                    type="button"
                    className={
                      btnSpacing
                        ? 'btn  rounded-0 lg:mt-2 mt-2 mb-6 md:mb-0'
                        : 'btn  rounded-0 lg:mt-4 mt-3 mb-6 md:mb-0'
                    }
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      fontSize: '18px',
                      padding: '13px 30px',
                    }}>
                    {btnTitle ? btnTitle : 'Know more'}
                  </button>
                </a>
              ) : (
                <a href={hrefExt} target="_blank" rel="noreferrer">
                  <button
                    type="button"
                    className="btn  rounded-0 lg:mt-4 mt-3 mb-6 md:mb-0"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      fontSize: '18px',
                      padding: '13px 30px',
                    }}>
                    {btnTitle ? btnTitle : 'Know more'}
                  </button>
                </a>
              )}
            </div>
          </div>
        )
      ) : bg == 'black' ? (
        <div className="grid md:grid-cols-2 mb-12 md:gap-x-10 gap-y-4 md:gap-y-10">
          <div className=" order-1 ">
            <img loading="lazy" className="img img-fluid w-full" src={imgsrc} alt="" />
          </div>
          <div className=" order-2 text-center  flex flex-col justify-center items-center">
            <h1 className="fs-24-30 font-semibold  lg:mb-1" style={{ fontFamily: 'Josefin Sans', color: '#ffffff' }}>
              {title}
            </h1>
            {subDetail ? (
              <p
                className=""
                style={{ fontFamily: 'Josefin Sans', color: '#a4a4a4', lineHeight: '30px', fontSize: '18px' }}>
                {subDetail}
              </p>
            ) : null}
            {discription}

            {btn == false || btn == undefined ? null : href ? (
              <Link href={href}>
                <button
                  type="button"
                  className="btn  rounded-0 lg:mt-4 mt-3 mb-4 md:mb-0"
                  style={{
                    fontFamily: 'Josefin Sans',
                    color: '#010101',
                    backgroundColor: '#FCBD00',
                    fontSize: '18px',
                    padding: '13px 30px',
                  }}>
                  {btnTitle ? btnTitle : 'Know more'}
                </button>
              </Link>
            ) : (
              <a ref={hrefExt} target="_blank" rel="noreferrer">
                <button
                  type="button"
                  className="btn  rounded-0 lg:mt-4 mt-3 mb-4 md:mb-0"
                  style={{
                    fontFamily: 'Josefin Sans',
                    color: '#010101',
                    backgroundColor: '#FCBD00',
                    fontSize: '18px',
                    padding: '13px 30px',
                  }}>
                  {btnTitle ? btnTitle : 'Know more'}
                </button>
              </a>
            )}
          </div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 mb-12  gap-x-10  md:gap-x-10 gap-y-10 md:gap-y-10">
          <div className=" order-1 ">
            <img loading="lazy" className="img img-fluid w-full" src={imgsrc} alt="" />
          </div>
          <div className=" order-2 text-center flex flex-col justify-center items-center">
            <h1 className="fs-24-30 font-semibold  lg:mb-1" style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
              {title}
            </h1>
            {subDetail ? (
              <p
                className=""
                style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px', fontSize: '18px' }}>
                {subDetail}
              </p>
            ) : null}
            <p
              className=" lg:mt-2 "
              style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px', fontSize: '18px' }}>
              {discription}
            </p>
            {btn == false || btn == undefined ? null : href ? (
              <a href={href} target={target && target}>
                <button
                  type="button"
                  className={
                    btnSpacing ? 'btn  rounded-0 lg:mt-2 mt-2 mb-4 md:mb-0' : 'btn  rounded-0 lg:mt-4 mt-3 mb-4 md:mb-0'
                  }
                  style={{
                    fontFamily: 'Josefin Sans',
                    color: '#010101',
                    backgroundColor: '#FCBD00',
                    fontSize: '18px',
                    padding: '13px 30px',
                  }}>
                  {btnTitle ? btnTitle : 'Know more'}
                </button>
              </a>
            ) : (
              <a href={hrefExt} target="_blank" rel="noreferrer">
                <button
                  type="button"
                  className="btn  rounded-0 lg:mt-4 mt-3 mb-4 md:mb-0"
                  style={{
                    fontFamily: 'Josefin Sans',
                    color: '#010101',
                    backgroundColor: '#FCBD00',
                    fontSize: '18px',
                    padding: '13px 30px',
                  }}>
                  {btnTitle ? btnTitle : 'Know more'}
                </button>
              </a>
            )}
          </div>
        </div>
      )}
      <Styles/>
    </>
  );
};

export default Pays;
